module.exports = __webpack_public_path__ + "static/media/partners.3bba632b.svg";